"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = _react["default"].memo(function (_ref) {
  var children = _ref.children,
      freeze = _ref.freeze,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "freeze", "variant"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({
    className: "Modal"
  }, props, {
    sx: _extends({
      overflow: 'auto',
      borderRadius: [0, 'large'],
      bg: 'white',
      boxShadow: ['none', 8],
      maxWidth: variant === 'large' ? ['100%', 14] : ['100%', 13],
      width: '100%',
      height: ['100%', 'auto'],
      marginY: 'auto'
    }, props.sx)
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      width: '100%',
      position: 'relative',
      flexDirection: 'column',
      flex: '1 1 auto',
      '@supports (padding-top: constant(safe-area-inset-top))': {
        mt: ['constant(safe-area-inset-top)', 0]
      },
      '@supports (padding-top: env(safe-area-inset-top))': {
        mt: ['env(safe-area-inset-top)', 0]
      }
    }
  }, children));
}, function (prev, next) {
  return next.freeze;
});

Modal.displayName = 'Modal';
Modal.propTypes = {
  variant: _propTypes["default"].oneOf(['small', 'large']),
  children: _propTypes["default"].node.isRequired
};
Modal.defaultProps = {
  variant: 'small'
};
var _default = Modal;
exports["default"] = _default;